import React from 'react';
import Title from '../../../../../@casino/ui/title';
import TableCasino from '../../../../../@casino/ui/table';
import { useDispatch, useSelector } from 'react-redux';
import {setGetListHistory} from '../../store/thunk/setGetListHistory';
import {getDate} from '../../../../../@casino/lib/getDate';

const AdminHistory = () => {
    const dispatch = useDispatch();

    const list_admin = useSelector((state) => state.admin.history);
    
    React.useEffect(() => {
        dispatch(setGetListHistory({
            page: 1,
            rowsPerPage: 10
        }));
    }, [])

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'event_date', label: 'Дата'},
        { id: 'login', label: 'Логин'},
        { id: 'description', label: 'Событие'},
        { id: 'ip', label: 'IP'}
    ];
  
    const rows = list_admin.data.map((item) => {
        return {
            id: item.id,
            event_date: getDate(item.event_date),
            login: item.login,
            description: item.description,
            ip: item.ip
        }
    })

    const [activeTab, setActiveTab] = React.useState('history');

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="История входов" />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <div style={{marginBottom: 12}}>
                    <span 
                        style={{fontFamily: 'Calibri, sans-serif', color: activeTab === 'history' ? 'pink' : '#fff', marginRight: 12, cursor: 'pointer'}}
                        onClick={() => setActiveTab('history')}
                    >История вход</span>
                    <span 
                        style={{fontFamily: 'Calibri, sans-serif', color: activeTab === 'access' ? 'pink' : '#fff', cursor: 'pointer'}}
                        onClick={() => setActiveTab('access')}    
                    >Доступные входы</span>
                </div>
                {
                    activeTab === 'history' && 
                    <TableCasino
                        width={1600}
                        pagination
                        allPage={list_admin.countPage}
                        perPage={10}
                        columns={columns}
                        rows={rows}
                        changePage={(v) => dispatch(setGetListHistory({
                            page: +v.page+1,
                            rowsPerPage: v.rowsPerPage
                        }))}
                        changeRowsPerPage={(v) => dispatch(setGetListHistory({
                            page: +v.page + 1,
                            rowsPerPage: v.rowsPerPage
                        }))}
                    />
                }
                {
                    activeTab === 'access' && 
                    <div style={{borderTop: '1px solid #fefefe', paddingTop: 12}}>
                        <div>
                            <label htmlFor="ip">
                                <span>Добавить ip адрес</span> 
                                <input 
                                    type="text" 
                                    name="" 
                                    id=""/>
                            </label>
                        </div>
                    </div>
                }
                
            </div>
        </div>
    )
}

export default AdminHistory;